"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LogoutConfirmDialog = require("./LogoutConfirmDialog");
Object.keys(_LogoutConfirmDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogoutConfirmDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LogoutConfirmDialog[key];
    }
  });
});
